import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import draggable from 'vuedraggable'
import EdSectionMaterial from '@/courses/components/ed-section-material/ed-section-material.vue';
import EdSectionMaterialObject from '@/courses/components/ed-section-material-object/ed-section-material-object.vue';
import { MaterialMixin } from '@/courses/mixins/material.mixin';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';

@Component({
  name: 'ed-section-material-tree',
  components: {
    EdSectionMaterial,
    EdSectionMaterialObject,
    draggable
  }
})
export default class EdSectionTreeMaterial extends Mixins(MaterialMixin) {
  
  /* Props */
  @Prop() readonly menuOptions: any[];

  /* Data */
  public sectionsOpened: number[] = [];
  public emptyDiv: any = null;
  
  /* Computed */
  get materialsList () {
    return this.course ? this.course.materialsList : [];
  }

  get materialsListLength () {
    return this.materialsList?.length > 0;
  }

  /* Methods */
  public openSection(sectionsOpened: number[]) {
    this.sectionsOpened = sectionsOpened;
  }

  public sectionMoved(element: any) {

    this.$Courses.Store.setMovingObject(false);
    /* change items to other section */
    if(element.added) {
      element.added.element.sectionParentId = null;
      element.added.element.parentId = null;
      if(element.added.element.data) {
        let index: number = this.materialsList.findIndex((mat: any) => mat.relatedContentId ===  element.added.element.relatedContentId);
        let data: any = {
          materialId: element.added.element.relatedContentId,
          materialSectionId: '',
          newOrder: index,
          courseId: this.courseID
        }
        this.$Courses.Store.moveCourseMaterialA(data);  
      } else {
        let index: number = this.materialsList.findIndex((sec: any) => sec.sectionId ===  element.added.element.sectionId);
        let data: any = {
          materialSectionId: element.added.element.sectionId,
          newMaterialSectionParentId: '',
          newOrder: index,
          courseId: this.courseID
        }
        this.$Courses.Store.moveCourseMaterialSectionA(data);
      }
    }

    /* reorder items */ 
    if(element.moved) {
      if(element.moved.element.data) {
        let index: number = this.materialsList.findIndex((mat: any) => mat.relatedContentId ===  element.moved.element.relatedContentId);
        let data: any = {
          materialId: element.moved.element.relatedContentId,
          materialSectionId: '',
          newOrder: index,
          courseId: this.courseID
        }
        this.$Courses.Store.moveCourseMaterialA(data);  
      } else {        
        let index: number = this.materialsList.findIndex((sec: any) => sec.sectionId ===  element.moved.element.sectionId);
        let data: any = {
          materialSectionId: element.moved.element.sectionId,
          newMaterialSectionParentId: '',
          newOrder: index,
          courseId: this.courseID
        }
        this.$Courses.Store.moveCourseMaterialSectionA(data);
      }      
    }

  }

  public moving(e) {
    if(e.to.className == 'parent-empty') {
      e.to.children[0].classList.add('edg-d--none');
      this.emptyDiv = e.to.children[0];
    } else {
      if(this.emptyDiv) {
        this.emptyDiv.classList.remove('edg-d--none');
        this.emptyDiv = null;
      }
    }
    if([...e.related.classList].includes('section-material')) {
      this.$Courses.Store.setMovingObject(true);
        this.$edEventBus.$emit(COURSES_EVENTS.MATERIAL_OPENED, { opened: true, sectionId: e.related.childNodes[0].id });
    }
    return true;
  }

  public sectionMoveEnd(e) {
    this.$Courses.Store.setMovingObject(false);
  }

}